import { PopupboxManager, PopupboxContainer } from 'react-popupbox';

function ImageLightbox(props) {
  const { imageUrl } = props;

  const displayPopupbox = () => {
    PopupboxManager.open({ content: <img src={imageUrl} style={{ minHeight: 1080 }} /> });
  };

  return (
    <>
      <a onClick={displayPopupbox}>
        <span className="fa fa-expand" />
        Expand image
      </a>
      <PopupboxContainer />
    </>
  );
}

export default ImageLightbox;
